export default __webpack_public_path__ + "static/media/game-over-man.a5c9fb1d.png";